import { render } from "./Gameboard_SidePanel_IS.vue?vue&type=template&id=69ccccee"
import script from "./Gameboard_SidePanel_IS.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_IS.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_IS.vue?vue&type=style&index=0&id=69ccccee&lang=scss"
script.render = render

export default script